import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { httpPost, httpPUT } from "../../common/petitions";

const CategoryModal = ({ isOpen, toggle, rubro,formData,reload }) => {
  const [localFormData, setLocalFormData] = useState(formData);
  const [cantidadFInal, setCantidadFInal] = useState(formData.valor);
  const [cantidad, setCantidad] = useState(formData.cantidad);
  const [operacion, setOperacion] = useState(formData.operacion);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === 'cantidad') {
      setCantidad(value);
      setCantidadFInal(operaciones(parseFloat(localFormData.total), parseFloat(value), operacion));
    } else if (id === 'operacion') {
      setOperacion(value);
      setCantidadFInal(operaciones(parseFloat(localFormData.total), parseFloat(cantidad), value));
    }
    setLocalFormData((prevState) => ({ ...prevState, [id]: value }));
  };

  useEffect(() => {
    if (formData) {
      setLocalFormData(formData);
      setCantidad(formData.cantidad || 0);
      setOperacion(formData.operacion || '');
      setCantidadFInal(formData.valor || 0);
    }
  }, [formData]);

  const validateInputs = (localData) => {
    if (!localData.operacion || !localData.cantidad || !localData.descri) {
      setMessage('Complete todos los datos por favor');
      setStatus('error');
      return false;
    }
    if (isNaN(localData.cantidad)) {
      setMessage('Cantidad deben ser numeros');
      setStatus('error');
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    // console.log(localFormData);
    localFormData.cantidad = cantidad;
    localFormData.operacion = operacion;
    localFormData.valor = cantidadFInal;
    const {    grupo, valor, descri, idunique } = localFormData;
    if (!validateInputs(localFormData)) return;
    try {
      if (idunique != null) {
        const data = {
          operacion,
          cantidad,
          valor,
          descri,
          
        };
        // console.log(data);
        await httpPUT(`/rubromodificar/${idunique}`, data);
      } else {
        console.log(rubro);
        const data = {
          categoria: localFormData.categoria,
          operacion,
          cantidad,
          tipo: localFormData.idgrupo,
          tipoDesc: grupo,
          valor,
          descri,
          rubro
        };
        console.log(data);
        await httpPost('/rubromodificar', data);
      }

      toggle()
      reload()
     // Refresh data after save if needed
    } catch (error) {
      console.error(error);
    }
  };

  const operaciones = (valor1, valor2, opera) => {
    switch (opera) {
      case 'suma':
        return valor1 + valor2;
      case 'resta':
        return valor1 - valor2;
      case 'multipli':
        return valor1 * valor2;
      case 'division':
        return valor1 / valor2;
      default:
        return null;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Modificar valor Categoria</ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col className="col-6">
              <FormGroup>
                <Label for="idcatego">Categoria</Label>
                <Input type="text" id="idcatego" value={localFormData.categoria || ''} disabled />
              </FormGroup>
            </Col>
            {localFormData.grupo &&
              (<Col className="col-6">
              <FormGroup>
                <Label for="grupo">Grupo</Label>
                <Input type="text" id="grupo" value={localFormData.grupo || ''} disabled />
              </FormGroup>
                      </Col>)
            }
            
            <Col className="col-4">
              <FormGroup>
                <Label for="total">Total original</Label>
                <Input type="text" id="total" value={localFormData.total || ''} disabled />
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="operacion">Operador</Label>
                <Input type="select" id="operacion" value={operacion || ''} onChange={handleChange}>
                  <option value="">---Seleccionar---</option>
                  <option value="suma">+</option>
                  <option value="resta">-</option>
                  <option value="multipli">x</option>
                  <option value="division">/</option>
                </Input>
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="cantidad">Valor a aplicar</Label>
                <Input type="number" id="cantidad" value={cantidad || ''} onChange={handleChange} />
              </FormGroup>
            </Col>
            <Col className="col-12">
              <FormGroup>
                <Label for="cantidadFInal">Valor final</Label>
                <Input type="number" id="cantidadFInal" value={cantidadFInal || ''} disabled />
              </FormGroup>
            </Col>
            <Col className="col-12">
              <FormGroup>
                <Label for="descri">Justificacion</Label>
                <Input type="textarea" id="descri" value={localFormData.descri || ''} onChange={handleChange} />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave}>Save</Button>{' '}
        <Button color="secondary" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default CategoryModal;
